import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function FacultyDepartments({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((f, i) => {
            const I = getIcon(f.icon);
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div className="p-8 rounded-3xl bg-olive-light/60 hover:bg-olive-light transition h-full">
                  <I className="text-olive" size={32} />
                  <EditableText value={f.title} onChange={(t) => updateItem(i, { title: t })} as="h4" className="font-display text-xl mt-4" />
                  <EditableText value={f.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="text-sm text-ink/70 mt-2 leading-relaxed" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FacultyDepartments;
